import React from "react";
import {
  COUNTRIES,
  countryFlagEmoji,
  getCountryByCode,
  isCountryEnabled,
  normalizeDial,
  resolveDialCountry,
} from "../../utils/countries";

export default function PhoneWithCountryCode({
  id,
  dial,
  national,
  countryName,
  onDialChange,
  onNationalChange,
  disabled = false,
  required = false,
  className = "",
}) {
  const selected = resolveDialCountry(dial, countryName);
  const selectValue = selected?.code || "";

  const handleDialChange = (event) => {
    const country = getCountryByCode(event.target.value);
    if (!country || typeof onDialChange !== "function") return;
    onDialChange(normalizeDial(country.dial) || country.dial, country);
  };

  const handleNationalChange = (event) => {
    if (typeof onNationalChange === "function") {
      onNationalChange(event.target.value);
    }
  };

  return (
    <div className={`pi-phone-field ${className}`.trim()}>
      <select
        aria-label="Country code"
        value={selectValue}
        onChange={handleDialChange}
        disabled={disabled}
        className="pi-phone-field__dial"
        title={selected ? `${selected.name} ${selected.dial}` : "Country code"}
      >
        {COUNTRIES.map((country) => {
          const flag = countryFlagEmoji(country.code);
          const enabled = isCountryEnabled(country.code);
          return (
            <option
              key={country.code}
              value={country.code}
              disabled={!enabled}
              title={`${country.name} ${country.dial}`}
            >
              {flag} {country.dial}
            </option>
          );
        })}
      </select>
      <input
        id={id}
        type="tel"
        inputMode="tel"
        autoComplete="tel-national"
        value={national || ""}
        onChange={handleNationalChange}
        disabled={disabled}
        required={required}
        className="pi-phone-field__number"
        placeholder="Mobile number"
      />
    </div>
  );
}
